// removed by extract-text-webpack-plugin
module.exports = {"imgRight":"Yy_7P41vijbrX7Dz1MyIg","imgLeft":"_2UL6i00P7uhpyetf7FSRNX","spaceBoth":"_90lJs_X7R6xfNZMzJAXjw","transactionFailedHash":"NluBphN093NNnGMfwRQ9y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TransactionStatus.scss
// module id = 1235
// module chunks = 0